import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_layout_1p+3",
  "use": "icon-icon_layout_1p+3-usage",
  "viewBox": "0 0 60 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 60 45\" id=\"icon-icon_layout_1p+3\">\n<path d=\"M0,0v45h60V0H0z M59,1v28.3H1V1H59z M39.3,30.3V44H20.7V30.3H39.3z M1,30.3h18.7V44H1V30.3z M40.3,44V30.3\n\tH59V44H40.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol